import _typeof from "@babel/runtime/helpers/typeof";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es6.function.name.js";

/* eslint-disable camelcase */
import React, { createContext, useEffect, useContext, useState } from 'react';
import { v4 as uuid } from 'uuid';
import { getLogger } from '@nerdwallet/logging';
import { useConstant } from "../../hooks/useConstant";
import { useSegmentAnalytics } from '..';
var logger = getLogger('AnalyticsPageView');

/**
 * AnalyticsPageViewContext will be used to provide the generated page_view_id or any other stored values to
 * other components if they need it for Segment tracking events.
 */
export var AnalyticsPageViewContext = /*#__PURE__*/createContext(null);
export var AnalyticsPageView = function AnalyticsPageView(_ref) {
  var _ref$name = _ref.name,
      name = _ref$name === void 0 ? '' : _ref$name,
      contentId = _ref.contentId,
      contentSource = _ref.contentSource,
      children = _ref.children;

  var _useSegmentAnalytics = useSegmentAnalytics(),
      analytics = _useSegmentAnalytics.analytics,
      deployable_name = _useSegmentAnalytics.deployable_name,
      deployable_version = _useSegmentAnalytics.deployable_version,
      deviceId = _useSegmentAnalytics.deviceId;

  var pageViewId = useConstant(function () {
    return uuid();
  });

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isHeaderPropsAvailable = _React$useState2[0],
      setIsHeaderPropsAvailable = _React$useState2[1];

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      pageViewReady = _useState2[0],
      setPageViewReady = _useState2[1];

  useEffect(function () {
    var timeout = setInterval(function () {
      var _window$nerdwallet, _window$nerdwallet$ui;

      var setHeaderPropsIsAvailable = (typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && typeof ((_window$nerdwallet = window.nerdwallet) === null || _window$nerdwallet === void 0 ? void 0 : (_window$nerdwallet$ui = _window$nerdwallet.ui) === null || _window$nerdwallet$ui === void 0 ? void 0 : _window$nerdwallet$ui.setHeaderProps) === 'function';

      if (setHeaderPropsIsAvailable) {
        setIsHeaderPropsAvailable(true);
        clearInterval(timeout);
      }
    }, 100);
    return function () {
      return clearInterval(timeout);
    };
  }, []);
  useEffect(function () {
    if (pageViewReady) {
      // The event has already fired
      return;
    }

    if (!analytics || !deviceId) {
      // Required params not present
      return;
    }

    var payload = {
      deployable_name: deployable_name,
      deployable_version: deployable_version,
      pageview_id: pageViewId,
      traditional_device_id: deviceId,
      content_id: contentId,
      content_source: contentSource
    };

    if (name) {
      analytics.page(name, payload);
    } else {
      analytics.page(payload);
    }

    setPageViewReady(true);
  }, [analytics, contentId, contentSource, deployable_name, deployable_version, deviceId, name, pageViewId, pageViewReady]);
  useEffect(function () {
    var _window$nerdwallet2, _window$nerdwallet2$u;

    if (!isHeaderPropsAvailable || !pageViewReady) return;
    (_window$nerdwallet2 = window.nerdwallet) === null || _window$nerdwallet2 === void 0 ? void 0 : (_window$nerdwallet2$u = _window$nerdwallet2.ui) === null || _window$nerdwallet2$u === void 0 ? void 0 : _window$nerdwallet2$u.setHeaderProps({
      segmentTrackingAttributes: {
        driverPageViewId: pageViewId
      }
    });
  }, [pageViewReady, isHeaderPropsAvailable, pageViewId]);
  return /*#__PURE__*/React.createElement(AnalyticsPageViewContext.Provider, {
    value: {
      pageName: name,
      pageViewId: pageViewId,
      pageViewReady: pageViewReady
    }
  }, children);
};
/**
 *
 * Hook to access all AnalyticsPageViewContext stored values
 * @returns context AnalyticsPageViewContext
 */

export var useAnalyticsPageView = function useAnalyticsPageView() {
  var context = useContext(AnalyticsPageViewContext);

  if (!context) {
    logger.error('useAnalyticsPageView must be used within a <AnalyticsPageView />');
    return null;
  }

  return context;
};